import styled from '@emotion/styled'

/**
 * Tabs — 단일 선택 그룹 (시각적으로 탭 모양, 의미적으로는 toggle button group).
 *
 * 시각 상태는 두 attribute로 분기:
 *   • `aria-pressed='true'` — 활성 (orange underline + bold/dark text)
 *   • `data-trailing` — 우측에 추가 요소(뱃지 등) 있음. 균등 분배 대신 고정 너비
 *
 * shouldForwardProp / 중첩 삼항자 없이 CSS attribute selector로만 처리해서
 * 마크업·스타일 모두 직관적으로 읽힌다.
 */
export const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  border-bottom: 1px solid #e4e5e7;
`

export const Tab = styled.button`
  position: relative;
  flex: 1 0 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 48px;
  padding: 14px 0 16px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.3px;
  color: #8a8f98;

  /* 활성 표시 — 부모 1px gray border 위에 2px orange를 겹쳐 그림 */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background: transparent;
    transition: background 120ms ease-out;
  }

  &[aria-pressed='true'] {
    font-weight: 700;
    color: #1a1a1a;
  }

  &[aria-pressed='true']::after {
    background: #ff5626;
  }

  /* trailing 요소(뱃지 등)가 있으면 균등 분배에서 빠지고 우측에 fit + 좌우 padding 더 줌 */
  &[data-trailing] {
    flex: 0 0 auto;
    padding: 14px 20px 16px 24px;
  }

  &:active {
    opacity: 0.7;
  }
`
